import { SyntheticEvent } from 'react';

import { Icon, IconButton } from '@atom/mui';
import { CloseIcon } from '@atom/mui/icons';
import { MapAsset } from '@atom/types/map';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import timeUtilities from '@atom/utilities/timeUtilities';

import { getStaticImage } from '../../mapUtilities';
import { getInactiveAssetIconFromSchemaMarkerId } from '../../markers/markerIconUtilities';

import classes from './list.module.css';

type AssetListItemProps = {
  asset: MapAsset;
  onSelect: (id: string) => void;
  onHover?: (id: string | null) => void;
  onExclude?: (id: string) => void;
};

const AssetListItem = ({
  asset,
  onSelect,
  onHover,
  onExclude,
}: AssetListItemProps) => {
  const {
    id,
    name,
    assetType,
    markerId,
    mainPhotoFileId,
    location,
    updatedDate,
  } = asset;

  const imageUrl = mainPhotoFileId
    ? `${FILES_ENDPOINT}/${mainPhotoFileId}_60`
    : getStaticImage(location, '60x60');

  const handleExclude = (event: SyntheticEvent) => {
    event.stopPropagation();
    onHover?.(null);
    onExclude?.(id);
  };

  return (
    <div
      className={classes.listItem}
      onClick={() => onSelect(id)}
      onMouseEnter={() => onHover?.(id)}
      onMouseLeave={() => onHover?.(null)}
      data-cy={`mapListAssetRow-${name}`}
    >
      <div className={classes.itemIcon}>
        <div
          className={classes.itemImage}
          style={{ backgroundImage: `url('${imageUrl}')` }}
        />
      </div>
      <div className={classes.itemBody}>
        <div className={classes.itemName}>{name}</div>
        <div className={classes.itemType}>
          <img
            className={classes.typeIcon}
            src={getInactiveAssetIconFromSchemaMarkerId(markerId)}
          />
          {assetType}
        </div>
        <div className={classes.itemDetail}>
          Last Updated: {timeUtilities.setDisplayDate(updatedDate)}
        </div>
      </div>
      {onExclude && (
        <div className={classes.excludeAction}>
          <IconButton
            size="small"
            edge="end"
            tooltip="Exclude"
            aria-label="Exclude"
            onClick={handleExclude}
            data-cy={`mapListExcludeButton-${name}`}
          >
            <Icon icon={CloseIcon} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default AssetListItem;
